import { useEffect } from 'react';
import { useToasts } from 'ui/toast';

const DEFAULT_ERROR_MESSAGE = 'Something went wrong. Please refresh and try again.';

/**
 * Hook to show a default error toast message
 * @param {Error|null} error - The error object to trigger the toast
 * @param {string} customMessage - Optional custom message to override the default
 * @returns {Function} showError - Function to manually trigger error toast
 */
export function useDefaultErrorToast(error = null, customMessage = null) {
  const { addToast } = useToasts();

  // Show toast when error prop changes
  useEffect(() => {
    if (error) {
      const message = customMessage || DEFAULT_ERROR_MESSAGE;
      addToast(message, { appearance: 'error' });
    }
  }, [error, customMessage, addToast]);

  // Return a function to manually show error toast
  const showError = (message = null) => {
    addToast(message || DEFAULT_ERROR_MESSAGE, { appearance: 'error' });
  };

  return showError;
}

export default useDefaultErrorToast;